import { Component, OnInit } from '@angular/core';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';

@Component({
  selector: 'app-trash',
  templateUrl: './trash.component.html',
  styleUrls: ['./trash.component.scss']
})
export class TrashComponent implements OnInit {

  constructor(private _dataSharingService: DataSharingService) { }

  ngOnInit(): void {
    this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager(null);
  }
  
  
}
